import React, { CSSProperties } from "react";
import { Select, SelectItem } from "@clarkinc/zest-design-system/ui";
import { PaymentMethod } from "../Models";
import SavedCard from "./SavedCard";
interface Props {
  isDisabled: boolean;
  tokenId?: number;
  savedCards: Readonly<PaymentMethod[]>;
  updateSelectedCard: (newCard: PaymentMethod) => void;
  styles: CSSProperties;
}
const SavedCardDropdown = ({
  isDisabled,
  tokenId,
  savedCards,
  updateSelectedCard,
  styles
}: Props) => {
  const selectedCard = savedCards.find(card => card.id === tokenId) || savedCards[0]!;
  const handleValueChange = (value: string) => {
    const newSelectedCard = savedCards.find(card => card.id === Number(value)) || selectedCard;
    if (newSelectedCard && !newSelectedCard.isExpired) {
      updateSelectedCard(newSelectedCard);
    }
  };
  return <div className="relative" style={styles} data-sentry-component="SavedCardDropdown" data-sentry-source-file="SavedCardDropdown.tsx">
      <Select theme="wss" label="Payment Method" hideLabel inputSize="large" placeholder="Select an option" disabled={isDisabled} value={savedCards.find(card => card.id === tokenId)?.id.toString() ?? savedCards[0]?.id.toString()} onValueChange={value => {
      handleValueChange(value);
    }} data-sentry-element="Select" data-sentry-source-file="SavedCardDropdown.tsx">
        {savedCards.map(card => <SelectItem value={card.id.toString()} key={card.id} disabled={card.isExpired}>
            <div className="leading-4">
              <SavedCard isExpired={card.isExpired} type={card.type} mask={card.mask} name={card.name} isRewardsCard={card.isRewardsCard} />
            </div>
          </SelectItem>)}
      </Select>
    </div>;
};
export default SavedCardDropdown;